import type { Maybe } from 'src/types';
import { pushEvent } from '../../../client/data-layer';

type Filters = {
  offset?: number | null;
  orderBy?: string | null;
};

type Sort = string | undefined | null;

type RatedArgs = {
  rating: number;
};

type StoreArgs = {
  storeId: number;
  storeName: string;
  type: ShopReviewType;
};

export enum ShopReviewType {
  PURCHASE = 'purchase',
  SHOP = 'shop',
}

export const productReviewsListed = (orderBy: Sort, filters: Filters) => {
  pushEvent('productReviewsListed', { orderBy, filters });
};

export const storeReviewsListed = (orderBy: Sort, filters: Filters) => {
  pushEvent('storeReviewsListed', { orderBy, filters });
};

export const productReviewCreated = () => {
  pushEvent('productReviewCreated');
};

export const storeReviewCreated = ({ type, storeId, storeName }: StoreArgs) => {
  pushEvent('storeReviewCreated', { type, storeId, storeName });
};

export const productRated = (rating: number) => {
  pushEvent('productRated', { rating });
};

export const storeRated = ({
  type,
  rating,
  storeId,
  storeName,
}: RatedArgs & StoreArgs) => {
  pushEvent('storeRated', { type, rating, storeId, storeName });
};

export const productReviewEdited = () => {
  pushEvent('productReviewEdited');
};

export const storeReviewEdited = ({ type, storeId, storeName }: StoreArgs) => {
  pushEvent('storeReviewEdited', { type, storeId, storeName });
};

export const productReviewDeleted = () => {
  pushEvent('productReviewDeleted');
};

export const storeReviewDeleted = ({ type, storeId, storeName }: StoreArgs) => {
  pushEvent('storeReviewDeleted', { type, storeId, storeName });
};

export const productReviewReported = () => {
  pushEvent('productReviewReported');
};

export const storeReviewReported = () => {
  pushEvent('storeReviewReported');
};

export const productReviewViewed = () => {
  pushEvent('productReviewViewed');
};

export const storeReviewViewed = () => {
  pushEvent('storeReviewViewed');
};

type VoteValue = 'like' | 'unlike';

export const productReviewVoted = (value: VoteValue) => {
  pushEvent('productReviewVoted', { value });
};

export const storeReviewVoted = (value: VoteValue) => {
  pushEvent('storeReviewVoted', { value });
};

export const trackStoreReviewFormViewed = ({
  type,
  storeId,
  storeName,
}: StoreArgs) => {
  pushEvent('storeReviewFormViewed', { type, storeId, storeName });
};

export const storeReviewPublished = ({
  type,
  storeId,
  storeName,
}: StoreArgs) => {
  pushEvent('storeReviewPublished', { type, storeId, storeName });
};

export const externalProductReviewsListed = (
  offset?: Maybe<number> | undefined
) => {
  pushEvent('externalProductReviewsListed', { offset });
};

export const externalProductReviewViewed = () => {
  pushEvent('externalProductReviewViewed');
};

export const externalProductReviewLinkClicked = () => {
  pushEvent('externalProductReviewLinkClicked');
};
